
import { store } from '../../store';
import Rest from '../../webapi/Rest';
import BaseActions from '../../app/_base_actions';
import update from 'immutability-helper';
import AppActions from '../../app/app_actions';
import { i18n, Utils, domain, domainVal, NumberFormatter, DateFormatter } from 'arm-common';
import { resolve } from 'path';
import { reject } from 'lodash';


const EnumCompagnieActions = Object.freeze({

    LIST_COMPAGNIE: 'LIST_COMPAGNIE',
    INITIALIZED: 'INITIALIZED',
    COMPAGNIA_DETAILS: 'COMPAGNIA_DETAILS',
    COMPAGNIA_HANDLE_CHANGE: 'COMPAGNIA_HANDLE_CHANGE',
    COMPAGNIA_UPDATE: 'COMPAGNIA_UPDATE',
    PUNTO_VENDITA_INITIALIZED: 'PUNTO_VENDITA_INITIALIZED',
    PUNTO_VENDITA_HANDLE_CHANGE: 'PUNTO_VENDITA_HANDLE_CHANGE'


});

module.exports.EnumCompagnieActions = EnumCompagnieActions;


class CompagnieActions extends BaseActions {
    constructor() {
        super();
        this.moduleName = "[CompagnieActions] ";
    }
    get Actions() {

        return EnumCompagnieActions;
    }


    getListCompagnie() {
        return function (dispatch) {
            return Rest.post('compagnia/listaCompagnia', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumCompagnieActions.LIST_COMPAGNIE, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    getCompagniaDetails(Id) {
        return function (dispatch) {
            return Rest.postForm('compagnia/compagniaDetails', { id: Id }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumCompagnieActions.COMPAGNIA_DETAILS, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }
    inizializzaNuovoPuntoVendita() {
        return function (dispatch) {
            dispatch({ type: EnumCompagnieActions.PUNTO_VENDITA_INITIALIZED });
        }
    }

    inizializzaNuovoCompagnia() {
        return function (dispatch) {
            let compagnia = {
                compagnia:
                {
                    $set: {}
                },
            }

            dispatch({
                type: EnumCompagnieActions.COMPAGNIA_UPDATE,
                compagnia: compagnia
            });
        }
    }

    inizializzaModificaCompagnia(id) {
        return function (dispatch, getState) {

            let compagnie = getState().compagnie.listaCompagnie;

            let com = compagnie.find(cmp => cmp.id === id);
            let compagnia = {
                compagnia:
                {
                    $set: com
                },
            }

            dispatch({
                type: EnumCompagnieActions.COMPAGNIA_UPDATE,
                compagnia: compagnia
            });
        }


    }


    handleChange(id, value) {
        return function (dispatch) {
            let object = {};
            object[id] = value;
            dispatch({
                type: EnumCompagnieActions.COMPAGNIA_HANDLE_CHANGE,
                dato: object
            });
        }
    }

    getListaPuntiVenditaDaAssociare(idCompagnia) {
        return function (dispatch) {
            return Rest.postForm('compagnia/listaPuntiVenditaDaAssociare', { idCompagnia: idCompagnia }, dispatch).then(
                resolve => {

                    let compagnia = {
                        puntiVendita:
                        {
                            $set: resolve
                        },
                    }

                    dispatch({
                        type: EnumCompagnieActions.COMPAGNIA_UPDATE,
                        compagnia: compagnia
                    });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    inputChangeHandlerPV(id, value) {

        return function (dispatch) {
            let object = {};
            object[id] = value;
            dispatch({
                type: EnumCompagnieActions.PUNTO_VENDITA_HANDLE_CHANGE,
                dato: object
            });
        }
    }


    getListaPuntiVenditaOfCompagnia(idCompagnia) {
        return (dispatch) => {

            return Rest.postForm('compagnia/listaPuntiVenditaOfCompagnia', { idCompagnia: idCompagnia }, dispatch).then(
                resolve => {
                    let compagnia = {
                        puntiVendita:
                        {
                            $set: resolve
                        },
                    }

                    dispatch({
                        type: EnumCompagnieActions.COMPAGNIA_UPDATE,
                        compagnia: compagnia
                    });

                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }

    salvaPV(idCompagnia) {

        return (dispatch, getState) => {

            let puntoVendita = getState().compagnie.puntoVendita;


            return Rest.post("compagnia/salvaPuntoVendita", puntoVendita, dispatch).then(

                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.COMPAGNIE.ACCORDO_INSERITA_CON_SUCCESSO', 'Punto vendita: [' + resolve.id + '] inserito con successo ')));
                    let accordoCmp = {
                        idPuntoVendita: resolve.id,
                        idCompagnia: idCompagnia
                    }
                    return Rest.post("compagnia/salvaAccordoCmp", accordoCmp, dispatch).then(
                        resolve => {
                            dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.COMPAGNIE.ACCORDO_INSERITA_CON_SUCCESSO', 'Punto vendita associato con la compagnia ' + resolve.idCompagnia)));
                            return resolve;
                        },
                        reject => {
                            return reject;
                        }


                    )
                    return resolve;
                }
            )
        }
    }

    salvaCompagnia() {
        return (dispatch, getState) => {

            let compagnia = getState().compagnie.compagnia;


            return Rest.post("compagnia/salvaCompagnia", compagnia, dispatch).then(

                resolve => {
                    if (compagnia.id) {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.COMPAGNIE.COMPAGNIA_INSERITA_CON_SUCCESSO', 'Comagnia: [' + resolve.id + '] modificata con successo ')));
                    } else {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.COMPAGNIE.COMPAGNIA_INSERITA_CON_SUCCESSO', 'Comagnia: [' + resolve.id + '] inserita con successo ')));
                    }
                    return resolve;

                }
            )
        }
    }

    deleteCompagnia(id) {
        return function (dispatch, getState) {
            return Rest.postForm('compagnia/eliminaCompagnia', { id: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.COMPAGNIA.COMPAGNIA_ELIMINATA_CON_SUCCESSO', 'Compagnia eliminata con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    deletePuntoVendita(id) {
        return function (dispatch, getState) {
            return Rest.postForm('compagnia/eliminaPuntoVendita', { id: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.COMPAGNIA.PV_ELIMINATA_CON_SUCCESSO', 'Punto Vendita eliminata con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }
};

export default CompagnieActions = new CompagnieActions;
